import { render, staticRenderFns } from "./baseOption.vue?vue&type=template&id=6f1bb2e0&scoped=true&"
import script from "./baseOption.vue?vue&type=script&lang=js&"
export * from "./baseOption.vue?vue&type=script&lang=js&"
import style0 from "./baseOption.vue?vue&type=style&index=0&id=6f1bb2e0&lang=scss&scoped=true&"
import style1 from "./baseOption.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1bb2e0",
  null
  
)

component.options.__file = "baseOption.vue"
export default component.exports